import { render, staticRenderFns } from "./puishment-list.vue?vue&type=template&id=0e1286da&scoped=true&"
import script from "./puishment-list.vue?vue&type=script&lang=js&"
export * from "./puishment-list.vue?vue&type=script&lang=js&"
import style0 from "./puishment-list.vue?vue&type=style&index=0&id=0e1286da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1286da",
  null
  
)

export default component.exports